import { getString } from "../../common/common";

export const RESEND = 'RESEND';
export const SEND_OTP = 'SEND_OTP';
export const OTP = 'OTP';
export const OTP_RESEND_MSZ = 'You_can_resend_the_OTP_now';
export const OTP_RESEND_OPT = 'You_can_resend_the_OTP_in';
export const RECENT_BOOKING = 'You_have_no_recent_bookings';
export const CNTRY_CODE = "CNTRY_CODE";
export const ENT_CC = "ENT_CC";

export const translations = {
    en: {
        [RESEND]: 'RESEND',
        [SEND_OTP]: 'SEND OTP',
        [OTP]: 'OTP',
        [OTP_RESEND_MSZ]: 'You can resend the OTP now',
        [OTP_RESEND_OPT]: 'You can resend the OTP in',
        [RECENT_BOOKING]: 'You have no recent bookings.',
        [CNTRY_CODE]: "Country Code",
        [ENT_CC]: "Enter Country Code",
    },
    kn: {
        [RESEND]: 'ಮತ್ತೆ ಕಳುಹಿಸಿ',
        [SEND_OTP]: 'OTP ಕಳುಹಿಸಿ',
        [OTP]: 'OTP', //todo
        [OTP_RESEND_MSZ]: 'ನೀವು ಈಗ OTPಯನ್ನು ಮತ್ತೆ ಕಳುಹಿಸಬಹುದು',
        [OTP_RESEND_OPT]: 'ನೀವು OTP ಅನ್ನು ಇಷ್ಟರೊಳಗೆ ಮತ್ತೆ ಕಳುಹಿಸಬಹುದು',
        [RECENT_BOOKING]: 'ನೀವು ಯಾವುದೇ ಇತ್ತೀಚಿನ ಬುಕಿಂಗ್‌ಗಳನ್ನು ಹೊಂದಿಲ್ಲ.',
        [CNTRY_CODE]: "Country Code",
        [ENT_CC]: "Enter Country Code",
    },
};

export const tPnrCommon = (key = "") => {
    return getString(key, translations)
}